import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const StationInfoModal = ({ isOpen, toggle, data }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Información de Estación</ModalHeader>
            <ModalBody>
                {data ? (
                    <div className="d-flex flex-column">
                        <div className="mb-3">
                            <strong>Estación Asignada:</strong>
                            <p className="text-muted mb-0">{data.name}</p>
                        </div>
                        <div>
                            <strong>Horas Límite:</strong>
                            <p className="text-muted mb-0">{data.hours_limit} horas</p>
                        </div>
                    </div>
                ) : (
                    <p>No hay información disponible.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary" onClick={toggle}>
                    Cerrar
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default StationInfoModal;
